import {Component, NgZone} from '@angular/core';
import {MainWindowComponent} from "./core/main-window/main-window.component";
import {ResizeService} from "./core/service/resize.service";
import {NavigationEnd, Router} from "@angular/router";
import {SessionService} from "./core/service/session.service";
import {MessageService} from "./core/service/message.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {InfoMessageComponent} from "./shared/dialog/info-message/info-message.component";
import {ErrorMessageComponent} from "./shared/dialog/error-message/error-message.component";
import {environment} from "../environments/environment";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends MainWindowComponent {
  title = environment.title;
  currentRootRoute = 'auth';
  isWideDisplay = window.innerWidth >= 1040;
  urlsHideMenu = ['login', 'update'];
  canOpenMenu: boolean = false;

  constructor(private resizeServce: ResizeService,
              private ngZone: NgZone,
              public router: Router,
              public sessionService: SessionService,
              private messageService: MessageService,
              private messageBar: MatSnackBar) {
    super(resizeServce, ngZone, 24);
    this.messageService.messageObservable.subscribe(message => {
      this.messageService.message = message;
      this.ngZone.run(() => {
        switch (message.type) {
          case 'info':
            this.messageBar.openFromComponent(InfoMessageComponent, {
              duration: 3000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
            break;
          case 'error':
            this.messageBar.openFromComponent(ErrorMessageComponent, {
              duration: 3000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
            break;
          default:
        }
      })
    })
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.url;
        const urlArr = url.split('/');
        if (urlArr && urlArr.length > 1) {
          this.currentRootRoute = urlArr[1];
          console.log(this.currentRootRoute)
        }
        this.canOpenMenu = !this.urlsHideMenu.some(u => url.indexOf(u) > -1);
      }
    })
  }
}
